"use client";

import { useRef, useState, useEffect } from "react";
import { IoArrowUp } from "react-icons/io5";
import { useSelector } from "react-redux";
import { selectCompareProducts } from "@/Redux/slice/compareSlice";

const ScrollableContentWrapper = ({ children }) => {
    const scrollContainerRef = useRef(null);
    const [showButton, setShowButton] = useState(false);
    const compareProducts = useSelector(selectCompareProducts);

    useEffect(() => {
        const container = scrollContainerRef.current;
        if (!container) return;

        const handleScroll = () => {
            const rect = container.getBoundingClientRect();
            const containerTop = rect.top;
            const containerHeight = container.scrollHeight;
            const viewportHeight = window.innerHeight;

            // Calculate how much of container has been scrolled past
            const scrolledPast = Math.max(0, -containerTop);
            const halfContainerHeight = containerHeight / 2;

            // Show button when scrolled past half the container height
            setShowButton(scrolledPast > halfContainerHeight);
        };

        window.addEventListener("scroll", handleScroll, true);
        handleScroll(); // Initial check

        return () => window.removeEventListener("scroll", handleScroll, true);
    }, []);

    const scrollToTop = () => {
        const container = scrollContainerRef.current;
        if (container) {
            container.scrollIntoView({ behavior: "smooth", block: "start" });
        }

    };

    return (
        <div ref={scrollContainerRef}>
            {children}
            {showButton && (
                <button
                    type="button"
                    onClick={scrollToTop}
                    className={`fixed right-6 z-50 bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-full shadow-lg transition-all duration-300 ease-in-out hover:scale-110 ${
                        compareProducts.length > 0
                            ? "bottom-40 sm:bottom-32 lg:bottom-40"
                            : "bottom-6"
                    }`}
                    aria-label="Scroll to top"
                >
                    <IoArrowUp size={24} />
                </button>
            )}
        </div>
    );
};

export default ScrollableContentWrapper;
